<ng-container *transloco="let t">
  <ng-container *ngIf="value$ | async as value">

    <label>{{t('check-work-unit-grp-proc-cat-assigned.workUnitId')}}:</label><span class="font-weight-bold">
      {{value.workUnitId | workUnitName | async}}</span>
    <label class="ml-2">{{t('check-work-unit-grp-proc-cat-assigned.workGroupIds')}}:</label>
    <span class="font-weight-bold">{{ value.workGroupId | workGroupName | async}}</span>
    <label class="ml-2">{{t('check-work-unit-grp-proc-cat-assigned.procedureCategoryId')}}:</label><span
      class="font-weight-bold">
      {{value.procedureCategoryId | procedureCategoryName | async}}</span>
    <label class="ml-2">{{t('check-work-unit-grp-proc-cat-assigned.isWorkUnitAssigned')}}</label><span
      class="font-weight-bold">
      {{value.isWorkUnitAssigned ? t('common.yes') : t('common.no')}}</span>

  </ng-container>
</ng-container>
